import React, { Component } from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

const baseURL = process.env.REACT_APP_API_BASE_URL;

export default class RecommendationSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      recs: [],
      expanded: [],
      selectedIds: [] // added for selected recommendations
    };
  }

  componentDidMount() {
    const { chatTask } = this.props;
    if (!chatTask || !chatTask.selectionDetail || !chatTask.selectionDetail.length) return;

    this.fetchRecommendation();
    this.fetchSelectedRecommendations();
  }

  fetchRecommendation() {
    const { chatTask } = this.props;
    const selectionDetails = chatTask.selectionDetail || [];
    this.setState({ loading: true });

    fetch(`${baseURL}/utils/fetchClientTasks.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        function: 'fetchSelectionDetailEntities',
        recordIDs: selectionDetails
      })
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then(({ records = [] }) => {
        this.setState({ recs: records });
        if (records.length > 0) {
          this.setState({ expanded: [records[0].id] });
        }
      })
      .catch((err) => console.error('Fetch error:', err))
      .finally(() => this.setState({ loading: false }));
  }

  fetchSelectedRecommendations() {
    const { chatTask, familyId } = this.props;
    const payload = {
      function: 'fetchSelectedEntities',
      TaskID: chatTask.id,
      FamilyID: familyId
    };
    fetch(`${baseURL}/utils/handleRecommendationSelection.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
      })
      .then((data) => {
        // Map SelectedEntities from each entry to an array of selected IDs
        const selectedIds = data.reduce((acc, curr) => {
          if (curr.SelectedEntities && Array.isArray(curr.SelectedEntities)) {
            return acc.concat(curr.SelectedEntities);
          }
          return acc;
        }, []);
        this.setState({ selectedIds });
      })
      .catch((err) => console.error('Fetch error:', err));
  }

  // Updated helper function to truncate description to 30 words
  truncateDescription(description) {
    if (!description) return '';
    const safeDesc = typeof description === 'string' ? description : String(description);
    const words = safeDesc.split(' ');
    return words.length > 15 ? words.slice(0, 15).join(' ') + '...' : safeDesc;
  }

  handleCardClick = (website) => {
    if (website) {
      window.open(website, '_blank', 'noopener,noreferrer');
    }
  };

  render() {
    const selectedItems = this.state.recs.filter((item) =>
      this.state.selectedIds.includes(item.id)
    );
    return (
      <div style={{ overflowY: 'auto', maxHeight: '80vh' }}>
        <h2>Selected recommendations from client</h2>
        {selectedItems.length === 0 ? (
          <p>Nothing selected yet</p>
        ) : (
          <Grid container spacing={2}>
            {selectedItems.map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.id}>
                <Card
                  onClick={() => this.handleCardClick(item.fields['Website'])}
                  style={{ cursor: item.fields['Website'] ? 'pointer' : 'default' }}
                >
                  {item.fields['Image Final'] && item.fields['Image Final'][0] && (
                    <CardMedia
                      component="img"
                      height="140"
                      image={item.fields['Image Final'][0].url}
                      alt={item.fields['Title']}
                    />
                  )}
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {item.fields['Title']}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.fields['Price Final']}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {this.truncateDescription(item.fields['Description Final'])}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
        <h2>Recommendation Items sent</h2>
        {this.state.loading && <p>Loading...</p>}
        <Grid container spacing={2}>
          {this.state.recs.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.id}>
              <Card
                onClick={() => this.handleCardClick(item.fields['Website'])}
                style={{ cursor: item.fields['Website'] ? 'pointer' : 'default' }}
              >
                {item.fields['Image Final'] && item.fields['Image Final'][0] && (
                  <CardMedia
                    component="img"
                    height="140"
                    image={item.fields['Image Final'][0].url}
                    alt={item.fields['Title']}
                  />
                )}
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    {item.fields['Title']}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item.fields['Price Final']}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {this.truncateDescription(item.fields['Description Final'])}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }
}
